module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open_request) ? _c('div', {}, [(_vm.loading) ? _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading-md"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#000000"
    }
  }, [_vm._v("Preparing and Checking your Sellpoint for previously added products and services")])]) : _c('form', {
    staticClass: "gw-form"
  }, [_c('h6', [_vm._v("Add a New Product Lookbook to your Gallery")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.showGalleryForm) ? _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_name),
      expression: "gallery.gallery_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "What's the Name of your Lookbook"
    },
    domProps: {
      "value": (_vm.gallery.gallery_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_description),
      expression: "gallery.gallery_description"
    }],
    attrs: {
      "placeholder": "What's this Lookbook all about"
    },
    domProps: {
      "value": (_vm.gallery.gallery_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_description = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.products.length > 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "font-size": "16px",
      "margin-bottom": "1em"
    }
  }, [_vm._v("Do you want to add from your products?")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n                        " + _vm._s(this.selected_produts) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row sp-products-row"
  }, _vm._l((_vm.products), function(p, pdex) {
    return _c('div', {
      key: pdex,
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "5px",
        "margin": "1em",
        "width": "10%",
        "height": "6em"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": p.product_name
      },
      on: {
        "click": function($event) {
          _vm.setComponent('add-to-gallery-product', p)
        }
      }
    }, [(p.product_images[0]) ? _c('div', {
      staticClass: "box-color-cube"
    }, [_c('sup', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.product_checked),
        expression: "p.product_checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": p.product_id + 'PRDC'
      },
      domProps: {
        "checked": Array.isArray(p.product_checked) ? _vm._i(p.product_checked, null) > -1 : (p.product_checked)
      },
      on: {
        "__c": function($event) {
          var $$a = p.product_checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (p.product_checked = $$a.concat($$v))
            } else {
              $$i > -1 && (p.product_checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            p.product_checked = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('img', {
      staticClass: "product-select sp-prd-img",
      staticStyle: {
        "height": "5em",
        "width": "95%"
      },
      attrs: {
        "src": p.product_images[0].product_image,
        "id": p.product_id + 'PRD'
      }
    })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "9px",
        "line-height": "1.2"
      }
    }, [_c('b', [_vm._v(_vm._s(p.product_name))])])])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', [_c('hr'), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ffcc00"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('show-add-product-form', '')
      }
    }
  }, [_c('b', [(_vm.products.length > 0) ? _c('span', [_vm._v(" Or ")]) : _vm._e(), _vm._v(" Add New Product / Service")])])]), _vm._v(" "), (_vm.showProductForm) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h6', [_vm._v("Add Product / Service")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn",
    staticStyle: {
      "background": "#cc6655",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('form', {
    staticClass: "gw-form",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_vm._v("Product")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "product")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "product"
      }
    }
  }), _vm._v("\n                                           \n                                     "), _c('label', [_vm._v(" Service ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "service"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "service")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "service"
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("is this a Product or Service?")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Name of Product / Service"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category ")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    attrs: {
      "placeholder": "Provide details of your product/service"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.is_product_service == 'product') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Weight(Kg)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quantity ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ffcc00"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pull-left btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add Product")]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.canAddGallery) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.addProductPost) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductPostGallery
    }
  }, [_vm._v("Add Post to Lookbook")]) : _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addGallery
    }
  }, [_vm._v("Add Lookbook")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(your product lookbook is a collection or group of products you want to keep together as posts)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Product lookbook Name "), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Select from your Products/Services to add to Lookbook")]), _vm._v(" (scroll to view all products)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(This would also be added to products in your sellpoint)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Select from My Shop Categories"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Price"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fb87b7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/posts/newproductgallery.vue
// module id = 617
// module chunks = 0